
import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent }    from './landing-aplicacion.component';

const PARAMETRO_ROUTES: Routes = [
  { path: 'landingAplicacion', component: LandingComponent }
];

export const ROUTABLE_COMPONENTS = [
];

@NgModule({
  imports: [
    RouterModule.forChild(PARAMETRO_ROUTES)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class LandingRoutingModule {}
